import { ClientUserDTO } from 'interfaces';

export const filterActiveClients = (clients: ClientUserDTO[]) =>
   clients.filter(user => user.active && !user.suspension.blocked);
